import React, { useEffect, useRef, useState } from "react";
import {
  downloadImage,
  months,
  getDayDiffBetweenFiscalMonths,
} from "../../../Utilitie";
import "../../PunctualityFolder/table.css";
import { useChartContext } from "../../../Context/ChartsContext";
import DownloadAsImage from "../../../Extra/DownloadAsImage";
import SingleTypeLineChart from "../../../CHARTS/SingleTypeLineChart";

const TYGraph = ({ defCode, yearDif, viewMonth, cMonthsData, chartType }) => {
  // const [yearDif, setYearDif] = useState(10);
  // const [viewMonth, setViewMonth] = useState(months);
  // const [cMonthsData, setCMonthsData] = useState(months);
  const [btnClick, setBtnClick] = useState(true);
  const [tableData, setTableData] = useState(null);
  const [colData, setColData] = useState([]);
  const [code, setCode] = useState(defCode);
  const storingChartData = [];
  const { bestSheetDataObj } = useChartContext();
  const reportRef = useRef(null);
  const handleYearChange = (e) => {
    // setYearDif(e.target.value);
  };
  const handleColChange = (e) => {
    setCode(e.target.value);
  };
  const avgColData = [
    "DWB",
    "SPEED",
    "DSL_KM",
    "AC_KM",
    "TOTAL_KM",
    "SPEED_INCLU_STB",
    "PUN_MAIL",
    "PUN_PASS",
    "TOD_RPT",
    "AC_USG",
    "DSL_USG",
    "WTR",
  ];
  const removeMsg = ["DWB", "SPEED", "SPEED_INCLU_STB"];
  const avgDayWise = ["TOTAL_RKS", "DESP_RKS", "RECEIPT_RKS"];
  useEffect(() => {
    let exclude = ["ID", "F_YEAR", "C_YEAR", "A_MONTH", "F_MONTH", "C_MONTH"];
    if (bestSheetDataObj.bestSheetData) {
      const keys = Object.entries(
        bestSheetDataObj.bestSheetData[0].months[0].data
      )
        .filter(([key]) => !exclude.includes(key)) // remove "ID"
        .map(([key]) => key); // extract keys

      setColData(keys);
    }
    const cMonths = [];
    if (bestSheetDataObj?.bestSheetData) {
      bestSheetDataObj?.bestSheetData[0]?.months.map((month) => [
        cMonths.push(month.A_MONTH.toUpperCase()),
      ]);
    }
    // setCMonthsData(cMonths);
  }, [bestSheetDataObj]);

  const handleBTN = () => {
    // if (btnClick) {
    //   const cMonths = [];
    //   bestSheetDataObj?.bestSheetData[0]?.months.map((month) => [
    //     cMonths.push(month.A_MONTH.toUpperCase()),
    //   ]);
    //   // setViewMonth(cMonths);
    //   setCMonthsData(cMonths);
    // } else {
    //   // setViewMonth(months);
    // }
    // setBtnClick(!btnClick);
  };

  const filterData = bestSheetDataObj?.bestSheetData?.filter((fyObj) => {
    const currentYear = fyObj?.F_YEAR?.substring(0, 4);
    const baseYear = bestSheetDataObj?.bestSheetData[0]?.F_YEAR?.substring(
      0,
      4
    );
    return currentYear > (parseInt(baseYear) - yearDif).toString();
  });

  useEffect(() => {
    const sortedData = filterData
      ?.slice()
      ?.sort(
        (a, b) => Number(a?.F_YEAR.slice(0, 4)) - Number(b?.F_YEAR.slice(0, 4))
      );
    setTableData(sortedData);
  }, [bestSheetDataObj, yearDif]);
  // /////////////////////////////////////////////////////

  return (
    <div className="">
      <div ref={reportRef}>
        <hr className="m-1" />
        <div className="d-flex align-items-center justify-content-around   p-1">
          <div style={{ fontSize: "12px" }}>
            {bestSheetDataObj.columnName &&
              bestSheetDataObj.columnName.map((obj, key) => {
                if (obj.original === defCode) {
                  return (
                    <h5 key={key} style={{}}>
                      {obj.label}{" "}
                      {avgColData.includes(code)
                        ? removeMsg.includes(code)
                          ? ""
                          : "(Avg per month)"
                        : avgDayWise.includes(code)
                        ? "(Avg per day)"
                        : ""}
                    </h5>
                  );
                }
              })}
          </div>
        </div>
        <div className="table-responsive">
          <table
            className="table table-striped-columns table-hover m-0 p-0"
            style={{
              fontSize: "12px",
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <tbody>
              {/* TOTAL Row */}
              <tr className="table-dark fw-bold">
                {tableData &&
                  tableData.forEach((fObj) => {
                    // Filter months present in viewMonth (case-insensitive)
                    const availableMonths = viewMonth
                      .map((m) => m.toUpperCase())
                      .filter((month) =>
                        fObj.months.some(
                          (mObj) => mObj?.A_MONTH?.toUpperCase() === month
                        )
                      );

                    // Calculate total for the filtered months
                    const total = availableMonths.reduce((sum, month) => {
                      const matchMonth = fObj.months.find(
                        (mObj) => mObj?.A_MONTH?.toUpperCase() === month
                      );
                      return (
                        sum + (matchMonth ? Number(matchMonth.data[code]) : 0)
                      );
                    }, 0);
                    // Defensive: avoid dividing by zero
                    const monthsCount = availableMonths.length || 1;
                    const totalDays =
                      availableMonths.length > 0
                        ? getDayDiffBetweenFiscalMonths(
                            fObj.F_YEAR,
                            availableMonths[0],
                            availableMonths[availableMonths.length - 1]
                          )
                        : 0;
                    // Calculate average or total depending on avgColData
                    const value = avgColData.includes(code)
                      ? Number((total / monthsCount).toFixed(2))
                      : avgDayWise.includes(code)
                      ? Number((total / totalDays).toFixed(2))
                      : Number(total.toFixed(2));

                    // Calculate totalDays if availableMonths exist

                    // Push data
                    storingChartData.push({
                      time: fObj.F_YEAR.replace("_", "-"),
                      [code]: value,
                    });
                  })}
              </tr>
            </tbody>
          </table>
        </div>
        <SingleTypeLineChart
          chartTypeData={chartType}
          data={storingChartData}
          title={code}
          singleValue={true}
          from="graph"
        />
      </div>
      <hr className="m-1" />
    </div>
  );
};
export default TYGraph;
